import PropTypes from 'prop-types';
import React from 'react';

import {withOverlay} from './utils';

class OverlayMarker extends React.Component {
  static displayName = 'OverlayMarker';

  static propTypes = {
    anchor: PropTypes.shape({
      x: PropTypes.number,
      y: PropTypes.number,
    }),
    animationDuration: PropTypes.number,
    bounds: PropTypes.object,
    children: PropTypes.node,
    position: PropTypes.shape({
      lat: PropTypes.number.isRequired,
      lng: PropTypes.number.isRequired,
    }).isRequired,
    positionToPixel: PropTypes.func.isRequired,
    zIndex: PropTypes.number,
  };

  static defaultProps = {
    anchor: {x: 0, y: 0},
    animationDuration: 0,
  };

  static getDerivedStateFromProps(props, prevState) {
    if (props) {
      if (props.bounds === prevState.bounds && props.animationDuration !== 0) {
        return {
          bounds: props.bounds,
          transition: `all ${props.animationDuration}s linear`,
        };
      }
      return {
        bounds: props.bounds,
        transition: 'none',
      };
    }
    return {transition: 'none'};
  }

  state = {
    bounds: null,
    transition: 'none',
  }

  componentDidMount() {
    if (this.props.animationDuration === 0) {
      this._transition = 'none';
    } else {
      this._transition = `all ${this.props.animationDuration}s linear`;
    }
  }

  render() {
    const {anchor} = this.props;
    const pixel = this.props.positionToPixel(this.props.position);
    if (pixel === null) return null;
    return (
      <div
        style={{
          position: 'absolute',
          top: pixel.y - anchor.y,
          left: pixel.x - anchor.x,
          transition: this.state.transition,
          zIndex: this.props.zIndex,
        }}
        data-id="overlay-marker"
      >
        {this.props.children}
      </div>
    );
  }
}

export default withOverlay(OverlayMarker);



// WEBPACK FOOTER //
// ./src/common/components/BetterMap/OverlayMarker.js